import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { SCRIPT_VALIDATORS } from './validators/script-validators';

@Directive({
  selector: '[scriptValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: ScriptValidatorDirective,
      multi: true
    }
  ]
})
export class ScriptValidatorDirective implements Validator {
  @Input() scriptValidator: string | string[];
  @Input() scriptField: any;

  validate(control: AbstractControl): ValidationErrors | null {
    const names = ([] as string[]).concat(this.scriptValidator || []).filter(Boolean);
    for (const name of names) {
      const validator = SCRIPT_VALIDATORS[name];
      if (!validator) {
        continue;
      }
      const result = validator.validate(control.value, this.scriptField);
      if (!result.valid) {
        return { scriptValidator: result.message || true };
      }
    }
    return null;
  }
}
